let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("17IHh")).then(() => parcelRequire('bZR3b'));